// Abertura do app (dono, 16/10/2026): a tela da logo (public/index.html) só
// sai quando a tela de destino está PRONTA — com banner, categorias e
// produtos no lugar — e sai com um esmaecimento. Antes ela saía assim que o
// React montava: aparecia uma tela branca de esqueleto, depois o banner, os
// ícones e os produtos iam surgindo e empurrando a página.
//
// Quem segura a abertura: a home e a página do produto avisam sozinhas; as
// outras telas avisam ao terminar de baixar o código delas (AberturaPronta no
// App). Teto de segurança no index.html: ela nunca fica presa.

/** Tira a tela da logo (idempotente: só a 1ª chamada vale). */
export const marcarAberturaPronta = () => {
  try { window.__aberturaPronta?.(); } catch { /* sem a abertura (testes): nada a fazer */ }
};

/** true depois que a tela da logo saiu (ou se ela nem existe, como nos testes). */
export const aberturaJaSaiu = () => {
  try { return !document.getElementById('pwa-splash') || !!window.__aberturaSaiu; } catch { return true; }
};

/** Chama `fn` quando a tela da logo terminar de sair (na hora, se já saiu). Devolve o cancelamento. */
export const depoisDaAbertura = (fn) => {
  if (aberturaJaSaiu()) { fn(); return () => {}; }
  const h = () => fn();
  window.addEventListener('toalugando:abertura:saiu', h, { once: true });
  return () => window.removeEventListener('toalugando:abertura:saiu', h);
};

/**
 * Espera as imagens já colocadas na página terminarem de carregar (e de
 * decodificar), com teto — para a logo sair com elas desenhadas, não vazias.
 */
export const esperarImagens = (imgs, tetoMs = 1500) => {
  const lista = Array.from(imgs || []).filter(Boolean);
  const uma = (img) => {
    if (img.complete && img.naturalWidth > 0) return Promise.resolve();
    if (typeof img.decode === 'function') return img.decode().catch(() => {});
    return new Promise((r) => { img.addEventListener('load', r, { once: true }); img.addEventListener('error', r, { once: true }); });
  };
  return Promise.race([
    Promise.all(lista.map(uma)),
    new Promise((r) => setTimeout(r, tetoMs)),
  ]);
};

/** Espera as imagens VISÍVEIS dentro de `raiz` (teto em ms) e tira a logo. */
export const prontoComImagensVisiveis = (raiz, tetoMs = 1500) => {
  requestAnimationFrame(() => {
    const alt = window.innerHeight;
    const imgs = raiz ? Array.from(raiz.querySelectorAll('img')).filter((i) => {
      const r = i.getBoundingClientRect();
      return r.width > 0 && r.bottom > 0 && r.top < alt;
    }) : [];
    esperarImagens(imgs, tetoMs).then(marcarAberturaPronta);
  });
};
